import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Preloader from '../components/Preloader';
import HeroVideo from '../components/HeroVideo';
import KeyFigures from '../components/KeyFigures';
import ManifesteBanner from '../components/ManifesteBanner';
import MasterplanSection from '../components/MasterplanSection';
import ProjectsShowcase from '../components/ProjectsShowcase';
import GalleryImmersive from '../components/GalleryImmersive';
import TeamSection from '../components/TeamSection';
import Footer from '../components/Footer';
import WhatsAppWidget from '../components/WhatsAppWidget';
import useVisitTracker from '../hooks/useVisitTracker';

const LandingPage = () => {
  const [showPreloader, setShowPreloader] = useState(true);
  const [contentReady, setContentReady] = useState(false);

  useVisitTracker();

  useEffect(() => {
    const preloaderShown = sessionStorage.getItem('preloaderShown');
    if (preloaderShown) {
      setShowPreloader(false);
      setContentReady(true);
    } else {
      // Content is always ready behind the preloader
      setContentReady(true);
    }
  }, []);

  const handlePreloaderComplete = () => {
    sessionStorage.setItem('preloaderShown', 'true');
    setShowPreloader(false);
  };

  return (
    <>
      {showPreloader && <Preloader onComplete={handlePreloaderComplete} />}
      
      <div className={`min-h-screen bg-white transition-opacity duration-300 ${
        contentReady ? 'opacity-100' : 'opacity-0'
      }`}>
        <Header />
        <main>
          {/* 1. Hero Video + Impact Bar overlay */}
          <div className="relative">
            <HeroVideo />
            <KeyFigures />
          </div>
          
          {/* 2. Manifeste Banner - Elegant transition with vision quote */}
          <ManifesteBanner />
          
          {/* 3. Projects Showcase - Fullscreen project carousel */}
          <ProjectsShowcase />
          
          {/* Visual transition: Projects → Le Grand Plan */}
          <div className="relative h-20 lg:h-28 bg-gradient-to-b from-stone-900 to-stone-950 overflow-hidden">
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-px h-10 bg-gradient-to-b from-transparent via-emerald-500/30 to-transparent" />
          </div>
          
          {/* 4. Masterplan - Interactive map with organic transition */}
          <MasterplanSection />
          
          {/* 5. Gallery - Progress and atmosphere images */}
          <GalleryImmersive />
          
          {/* 6. Team - Key contacts */}
          <TeamSection />
        </main>
        <Footer />
        <WhatsAppWidget />
      </div>
    </>
  );
};

export default LandingPage;
